import { Ruler } from "lucide-react";

/**
 * FEMBOT NEX system note for sizing range.
 *
 * Variants:
 *  - "default"  → block note for catalog pages (Shop / Drop 001)
 *  - "compact"  → inline note for the product detail right column
 *
 * The note shares the same hot-pink accent + JetBrains Mono micro-label
 * language as other system messages on the site, so it reads as terminal
 * output rather than a legal disclaimer.
 */
export default function SizingNote({ variant = "default" }) {
  if (variant === "compact") {
    return (
      <div
        data-testid="sizing-note-compact"
        className="relative border border-[#2a1a3a] bg-[#0a0316]/70 backdrop-blur-sm px-4 py-3"
      >
        <span
          aria-hidden="true"
          className="absolute left-0 top-0 bottom-0 w-[3px] bg-[#ff1493] shadow-[0_0_12px_rgba(255,20,147,0.55)]"
        />
        <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase text-[#ff1493]">
          <Ruler size={11} strokeWidth={1.5} />
          // System Note · Sizing
        </div>
        <p className="mt-1.5 font-mono text-[11px] leading-relaxed text-[#c8b8e0]">
          Drop 001 sizing ranges from{" "}
          <span className="text-white font-semibold">XXS–XL</span> depending on the
          product. Not every piece runs in every size. Check fit notes before
          preorder.
        </p>
      </div>
    );
  }

  return (
    <div
      data-testid="sizing-note"
      className="relative max-w-3xl border border-[#2a1a3a] bg-[#0a0316]/70 backdrop-blur-sm pl-5 pr-5 sm:pl-7 sm:pr-7 py-4 sm:py-5"
    >
      <span
        aria-hidden="true"
        className="absolute left-0 top-0 bottom-0 w-[4px] bg-[#ff1493] shadow-[0_0_18px_rgba(255,20,147,0.6)]"
      />
      <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.24em] uppercase text-[#ff1493]">
        <Ruler size={12} strokeWidth={1.5} />
        // System Note · Sizing Range
      </div>
      <p className="mt-2 font-mono text-[12px] sm:text-[13px] leading-relaxed text-[#c8b8e0]">
        Drop 001 sizing ranges from{" "}
        <span className="text-white font-semibold">XXS–XL</span> depending on the
        product. Not every piece is available in every size. Check each product&rsquo;s
        fit notes before preorder access opens.
      </p>
    </div>
  );
}
